export default __webpack_public_path__ + "static/media/docker.ea8b6193.png";